module.exports = __webpack_public_path__ + "static/media/journal1.6fbbdb29.png";